export const VALIDATION_STATUSES = {
  ACCEPT: 'ACCEPT',
  CANCEL: 'CANCEL',
  INVALID: 'INVALID',
  VALID: 'VALID',
};
